import {stashPortalMigrationTourShouldShow} from 'src/lib/portal-migration/portal-migration-tour-session'
import api from 'src/services/api'

type PortalMigrationTourStatus = {
  shouldShowPortalMigrationTour: boolean
}

function parsePortalMigrationTourPayload(data: unknown): PortalMigrationTourStatus {
  if (data && typeof data === 'object' && 'shouldShowPortalMigrationTour' in data) {
    const v = (data as {shouldShowPortalMigrationTour?: unknown}).shouldShowPortalMigrationTour
    return {shouldShowPortalMigrationTour: v === true}
  }
  return {shouldShowPortalMigrationTour: false}
}

let inflight: Promise<PortalMigrationTourStatus> | null = null

export function fetchPortalMigrationTourStatus() {
  if (!inflight) {
    inflight = api.users.getPortalMigrationTour().then((response) => {
      const parsed = parsePortalMigrationTourPayload(response.data?.data)
      stashPortalMigrationTourShouldShow(parsed.shouldShowPortalMigrationTour)
      return parsed
    })
  }
  return inflight.finally(() => {
    inflight = null
  })
}

export async function dismissPortalMigrationTour() {
  await api.users.dismissPortalMigrationTour()
  stashPortalMigrationTourShouldShow(false)
}
